import { render, staticRenderFns } from "./Tab-PreOrder.vue?vue&type=template&id=39b0c86d"
import script from "./Tab-PreOrder.vue?vue&type=script&lang=js"
export * from "./Tab-PreOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports